// extracted by mini-css-extract-plugin
export default {"minAmount":"CustomerDataForm_minAmount__sl0mZ"};